export const Z_INDEX = {
    AUTO: 'auto',
    INTERN_1: 1,
    INTERN_2: 2,
    INTERN_3: 3,
    STICKY: 4,
    POPUP: 5,
    FLOATING: 6,
    OVERLAY: 7,
    MODAL: 8,
    SPINNER: 11,
    TOAST: 12,
    TOP_OF_THE_WORLD: 13,
};
//# sourceMappingURL=zIndex.js.map